import { APP_PERMISSIONS } from '@exam-center/permission';
import { AddRoundedIcon, Button, type ButtonProps } from '@shared/components';
import { WithPermission } from '@shared/permissions';

export default function CreateAnnouncementButton(props: Readonly<ButtonProps>) {
  const { onClick, ...restProps } = props;
  return (
    <WithPermission
      requiredPermission={[
        APP_PERMISSIONS.ADMIN_ANNOUNCEMENT_MANAGEMENT.WEB_REGISTER_ANNOUNCEMENT.CREATE,
      ]}
    >
      <Button size='large' startIcon={<AddRoundedIcon />} onClick={onClick} {...restProps}>
        สร้างประกาศ
      </Button>
    </WithPermission>
  );
}
